import React from 'react'

const Text = ({children}) => (
  <div className="text-xl lg:text-right text-center lg:mx-auto m-12 mx-5 mt-10 max-w-6xl">
    {children}
  </div>
)
export default Text
